import { useState } from "react";
import { Fade } from "react-awesome-reveal";
import { useSearchParams } from "react-router-dom";
import { EyeIcon, WebLogo } from "utils/Icons";

const Form = ({ formData, setFormData, handleSignUp, isSubmitting }) => {
  // hide/show password
  const [showPass, setShowPass] = useState(false);
  //
  const [searchParams] = useSearchParams();
  const paramsEmail = searchParams.get("email");

  // handle form input
  const handleForm = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <form onSubmit={handleSignUp} className="signup_card_inner ">
      <div className="step_card_body justify_content_start">
        <Fade triggerOnce delay={200} duration={1000}>
          <WebLogo className="mx_auto" />
        </Fade>
        <br />
        {/* <Fade triggerOnce delay={400} duration={1200}>
          <h3>Now, it's YOUR turn. </h3>
        </Fade> */}
        <div className="input_wrapper">
          <input
            name="fullName"
            type="text"
            required
            onChange={handleForm}
            value={formData?.fullName}
          />
          <div className="input_underline"></div>
          <label>What's your name?</label>
        </div>
        <div className="input_wrapper">
          {paramsEmail ? (
            <input
              name="email"
              type="email"
              readOnly
              formNoValidate
              required
              valid="true"
              defaultValue={paramsEmail}
              style={{ cursor: "not-allowed" }}
            />
          ) : (
            <input
              name="email"
              type="email"
              required
              onChange={handleForm}
              value={formData?.email}
            />
          )}
          <div className={`input_underline ${paramsEmail ? 'active' : formData.email ? 'active' : ''}`}></div>
          <label className={` ${paramsEmail ? 'active' : formData.email ? 'active' : ''}`}>Email</label>
        </div>
        <div className="input_wrapper">
          <input
            name="password"
            type={showPass ? "text" : "Password"}
            required
            onChange={handleForm}
            value={formData?.password}
          />
          <div
            role="button"
            onClick={() => setShowPass((state) => !state)}
            className="input_show_pass_icon"
          >
            <EyeIcon className={showPass ? "showpass" : ""} />
          </div>
          <div className="input_underline"></div>
          <label>Create a password</label>
        </div>
        <p style={{textAlign: "left", marginTop: "5px"}}>
         Password must be at least 6 characters
        </p>
      </div>
      <br />
      <div className="mt_auto screen_sticky_footer">
        <Fade triggerOnce delay={1400} duration={1300}>
          <button
            type="submit"
            disabled={isSubmitting}
            className="cs_btn w_100"
          >
            {isSubmitting ? " Submitting... " : " Continue with Email"}
          </button>
        </Fade>
      </div>
    </form>
  );
};

export default Form;
